import style from './icon.module.css'

export const ProfileIconMenu = () => {
    return(
        <svg width="46" height="46" viewBox="0 0 24 24" className={style.icon}>
  <path d="M15.75 9.5a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"></path>
  <path fill-rule="evenodd" d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm10-8.75a8.75 8.75 0 0 0-6.835 14.212C6.053 16.032 8.006 14.5 12 14.5c3.994 0 5.946 1.531 6.835 2.962A8.75 8.75 0 0 0 12 3.25Z" clip-rule="evenodd"></path>
</svg>
    )
}